import { CellRouter } from 'cell-router';
import { FC, lazy } from 'web-cell';

import { PageFrame } from '../component/PageFrame';
import { Route } from '../utility';
import { SignInPage } from './SignIn';

const ModelListPage = lazy(() => import('./Model')),
    ModelDetailPage = lazy(() => import('./Model/detail')),
    ModelEditorPage = lazy(() => import('./Model/editor')),
    ModelConfiguratorPage = lazy(() => import('./Model/configurator')),
    ApplicationListPage = lazy(() => import('./Application')),
    ApplicationDetailPage = lazy(() => import('./Application/detail')),
    ApplicationEditorPage = lazy(() => import('./Application/editor')),
    BitMapViewer = lazy(() => import('./BitMap')),
    BitMapEditor = lazy(() => import('./BitMap/editor'));

export const App: FC = () => (
    <CellRouter>
        <Route path="" component={SignInPage} />
        <Route
            path="admin"
            component={() => (
                <PageFrame>
                    <ApplicationListPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/model"
            component={() => (
                <PageFrame>
                    <ModelListPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/model/:name([^\/]+)/version"
            component={() => (
                <PageFrame>
                    <ModelListPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/model/:name([^\/]+)@:version"
            component={() => (
                <PageFrame>
                    <ModelDetailPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/model/editor/:name?{@:version}?"
            component={() => (
                <PageFrame>
                    <ModelEditorPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/model/configurator/:name?{@:version}?"
            component={() => (
                <PageFrame>
                    <ModelConfiguratorPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/application"
            component={() => (
                <PageFrame>
                    <ApplicationListPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/application/:name([^\/]+)/version"
            component={() => (
                <PageFrame>
                    <ApplicationListPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/application/:name([^\/]+)@:version"
            component={() => (
                <PageFrame>
                    <ApplicationDetailPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/application/editor/:name?{@:version}?"
            component={() => (
                <PageFrame>
                    <ApplicationEditorPage />
                </PageFrame>
            )}
        />
        <Route
            path="admin/bit-map"
            component={() => (
                <PageFrame>
                    <BitMapViewer />
                </PageFrame>
            )}
        />
        <Route
            path="admin/bit-map/editor"
            component={() => (
                <PageFrame>
                    <BitMapEditor />
                </PageFrame>
            )}
        />
    </CellRouter>
);
